import React from 'react';
import { Outlet } from 'react-router-dom';

import { LayoutPublic } from '../../../layouts';

const Auth = () => {
  return (
    <LayoutPublic>
      <Outlet />
    </LayoutPublic>
  );
};

export default Auth;
